import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { api } from "./api";
import { rolesFromClaims } from "./authConfig";
import type { Location } from "./types";

export function useRoles() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];
  const roles = rolesFromClaims(account?.idTokenClaims as Record<string, unknown> | undefined);
  return {
    roles,
    isAdmin: roles.includes("Administrator"),
    name: (account?.idTokenClaims as { name?: string })?.name ?? account?.username ?? "",
    username: account?.username ?? "",
  };
}

export function useLocations() {
  const [locations, setLocations] = useState<Location[]>([]);
  useEffect(() => {
    api.locations().then((r) => setLocations(r.locations)).catch(() => setLocations([]));
  }, []);
  return locations;
}
